/**
 * LinRegrChannel — Canais de Regressão Linear.
 *
 * Migrado do Silverlight (GraficoDePrata/Formulas/FMLOutros.cs, classe
 * FML.LinRegr), overlay de preço, canal ESTÁTICO sobre as ÚLTIMAS N barras
 * (NaN antes — ≠ regressão rolling do tsma/linearForecast):
 *
 *   A     = LR(C, N)                              (reta least-squares da janela final)
 *   DIST  = C − A
 *   M     = MAX(MAXVALUE(DIST), |MINVALUE(DIST)|) · P / 100   (escalar)
 *   UPPER = A + M      LOWER = A − M
 *
 * Pacote do engine = [UPPER, LOWER, A]; renderizado como {top, middle, bottom}.
 * MAXVALUE/MINVALUE pulam NaN → reduzem só sobre as N barras onde DIST existe.
 * Paridade provada em __tests__/linRegrChannel.silverlight.test.js.
 */
import { getSourcePathAccessor } from "../utils";
import { lr, sub, maxValue, minValue } from "./silverlightDsl";
import { LinRegrChannel as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { period, percent, sourcePath } = options;

    const source = getSourcePathAccessor(sourcePath);
    const c = data.map((d, i) => {
      const v = source(d, i);
      return Number.isFinite(v) ? v : NaN;
    });

    const a = lr(c, period); // reta na janela final, NaN antes
    const dist = sub(c, a);
    // M escalar (mesma ordem do engine): max(maxDist, |minDist|)·P/100.
    const m =
      (Math.max(maxValue(dist), Math.abs(minValue(dist))) * percent) / 100;

    // Só a janela final tem valores (A finito); resto = undefined.
    return a.map((av) =>
      Number.isFinite(av)
        ? { top: av + m, middle: av, bottom: av - m }
        : undefined,
    );
  }

  // Indicador ancorado à DIREITA (canal na janela final) — sem warm-up à esquerda
  // no sentido tradicional; os undefined por barra tratam o render.
  calculator.undefinedLength = function () {
    return 0;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
